import { ADD_COMPONENT_SUCCESS, type AddComponentSuccessAction } from '../../actions.tsx';
import { INITIATE, CANCEL, type InitiateAction, type CancelAction } from './actions.tsx';

export type AddState = {
	isOpen: boolean;
};

type Action = InitiateAction | CancelAction | AddComponentSuccessAction;

export const initialState: AddState = { isOpen: false };

const add = (state: AddState = initialState, action: Action): AddState => {
	switch (action.type) {
		case INITIATE: {
			return { isOpen: true };
		}

		case ADD_COMPONENT_SUCCESS:
		case CANCEL: {
			return { isOpen: false };
		}

		default:
			return state;
	}
};

export default add;
